import { createAttachmentUploadOptions } from 'scripts/service'

interface UploadAttachmentProps {
  file: File
  urlToken: string
  fieldCode: string
  onSuccess?: (fileKey: string) => void
  onFail?: () => void
}

export default function useUploadAttachment() {
  return ({ file, urlToken, fieldCode, onSuccess, onFail }: UploadAttachmentProps) => {
    createAttachmentUploadOptions({
      fileName: file.name,
      fieldCode,
      urlToken,
    })
      .then((data: any) => {
        if (data?.createAttachmentUploadOptions) {
          const { key, url, contentType } = data.createAttachmentUploadOptions

          const xhr = new XMLHttpRequest()
          xhr.open('PUT', url, true)
          xhr.setRequestHeader('Content-Type', contentType || file.type)

          xhr.onload = () => {
            onSuccess?.(key)
          }

          xhr.onerror = () => {
            console.error('Upload attachment failed')
            onFail?.()
          }

          xhr.send(file)
        }
      })
      .catch(() => onFail?.())
  }
}
